<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="analysis__icon"
  >
    <path
      d="M16.2508 8.1254C16.2508 9.91845 15.6687 11.5748 14.6882 12.9186L19.6338 17.8681C20.1221 18.3564 20.1221 19.1494 19.6338 19.6377C19.1455 20.126 18.3525 20.126 17.8642 19.6377L12.9186 14.6882C11.5748 15.6726 9.91845 16.2508 8.1254 16.2508C3.6369 16.2508 0 12.6139 0 8.1254C0 3.6369 3.6369 0 8.1254 0C12.6139 0 16.2508 3.6369 16.2508 8.1254ZM4.0627 8.43791V10.938C4.0627 11.4576 4.48069 11.8756 5.00024 11.8756C5.5198 11.8756 5.93779 11.4576 5.93779 10.938V8.43791C5.93779 7.91836 5.5198 7.50037 5.00024 7.50037C4.48069 7.50037 4.0627 7.91836 4.0627 8.43791ZM7.18785 4.68773V10.938C7.18785 11.4576 7.60584 11.8756 8.1254 11.8756C8.64495 11.8756 9.06294 11.4576 9.06294 10.938V4.68773C9.06294 4.16817 8.64495 3.75018 8.1254 3.75018C7.60584 3.75018 7.18785 4.16817 7.18785 4.68773ZM10.313 7.18785V10.938C10.313 11.4576 10.731 11.8756 11.2505 11.8756C11.7701 11.8756 12.1881 11.4576 12.1881 10.938V7.18785C12.1881 6.66829 11.7701 6.25031 11.2505 6.25031C10.731 6.25031 10.313 6.66829 10.313 7.18785Z"
      :fill="colorHover"
    />
  </svg>
</template>

<script>
export default {
  name: "AnalysisIcon",
  props: {
    colorHover: {
      required: false,
      type: String,
      default: "var(--textinactive)"
    }
  }
};
</script>
